export default __webpack_public_path__ + "static/media/pic46.e5c4750e.jpg";